import type { BotStageChangedMessageWebSocket } from "@/Modules/Chat/Models/WebSocket";
import type { EventFilter } from "@/Modules/Chat/WebSocketManager";
import type { BotStage } from "@/Modules/Models/Domain/FlexoBot";
import { MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";

import { type ChatStore, useChatStore } from "@/Modules/Chat/Store";
import BotStageApiToBotStageTransformer from "@/Modules/Transformers/Chat/Bot/BotStageApiToBotStage";

import { isObject } from "@/Utils/Objects";

export interface ExtraParamsBotStageChanged {
  chatStore: ChatStore;
}
export const isBotStageChanged = (message: unknown): message is BotStageChangedMessageWebSocket => {
  return isObject(message) && message.type === MessageTypeWebSocket.BOT_STAGE_CHANGED;
};

export const botStageChangedHandler = async (
  message: BotStageChangedMessageWebSocket,
  { chatStore = useChatStore() }: ExtraParamsBotStageChanged
): Promise<BotStage> => {
  const transformer = new BotStageApiToBotStageTransformer();
  const botStage = await transformer.transform(message.data);

  chatStore.botStage = botStage;
  chatStore.isStartingAnswer = false;

  return botStage;
};

export default {
  isType: isBotStageChanged,
  handler: botStageChangedHandler,
} as EventFilter<ExtraParamsBotStageChanged>;
